import { memo, useEffect, useState } from 'react';
import { StyleTextInput } from '../style/StyleTextInput';

/**
 * A band's upper bound as typed: the text stays while it is not a number
 * yet ("1.", "-"), and the band takes NaN until it is.
 */
export const BandBoundInput = memo(
  ({
    label,
    value,
    onChange,
  }: {
    label: string;
    value: number;
    onChange: (next: number) => void;
  }) => {
    const [text, setText] = useState(
      Number.isFinite(value) ? String(value) : '',
    );
    // A row reused for another band (one above was removed) shows its bound.
    useEffect(() => {
      setText(current => {
        const parsed = current.trim() === '' ? NaN : Number(current);
        if (Object.is(parsed, value) || (isNaN(parsed) && isNaN(value)))
          return current;
        return Number.isFinite(value) ? String(value) : '';
      });
    }, [value]);
    return (
      <StyleTextInput
        label={label}
        value={text}
        placeholder="上限"
        numeric
        maxLength={12}
        onChange={next => {
          setText(next);
          const parsed = next.trim() === '' ? NaN : Number(next);
          onChange(Number.isFinite(parsed) ? parsed : NaN);
        }}
      />
    );
  },
);
